// src/components/Color.js
const getCssVar = (name, fallback) => {
  return (
    getComputedStyle(document.documentElement).getPropertyValue(name).trim() ||
    fallback
  );
};

const Color = {
  primary: {
    get main() {
      return getCssVar("--website-primary-color", "#D0021B");
    },
    contrastText: "#ffffff",
  },
  secondary: {
    get main() {
      return getCssVar("--website-secondary-color", "#7C0BCC");
    },
    contrastText: "#ffffff",
  },
  invoice: {
    get primary() {
      return getCssVar("--invoice-primary-color", "#D0021B");
    },
    get secondary() {
      return getCssVar("--invoice-secondary-color", "#7C0BCC");
    },
  },
  label: { main: "#00000099", secondary: "#444444ff" },
  success: { main: "#4caf50", contrastText: "#ffffff" },
  warning: { main: "#ff9800", contrastText: "#000000" },
  error: { main: "#f44336", contrastText: "#ffffff" },
  info: { main: "#2196f3", contrastText: "#ffffff" },
  neutral: {
    black: "#000000",
    white: "#ffffff",
    grayLight: "#f5f5f5",
    gray: "#9e9e9e",
    grayDark: "#424242",
  },
  background: { default: "#fafafa", paper: "#ffffff" },
  text: { primary: "#212121", secondary: "#757575", disabled: "#9e9e9e" },
};

export default Color;
